// src/belediye/components/mesajlasma/KonumBlok.js
// MESAJDAKİ KONUM — TEK KAYNAK (mini harita + yol tarifi + tam ekran).
//
// FAZ-66'da buraya taşındı. Eskiden RefMessageCard'ın içinde özel bir
// fonksiyondu; artık İKİ tüketicisi var:
//   • görev/başvuru kartındaki görev konumu (RefMessageCard),
//   • sohbette paylaşılan konum mesajı (ChatThread — ataç ▸ "Konum gönder").
// Kopyalamak, "haritayı tam ekran aç" ya da "yol tarifi" kuralının bir gün
// yalnız bir yerde değişmesi demekti (EkGrid'de aynı gerekçeyle birleştirildi).
import React, { Suspense, lazy, useState } from "react";
import { ArrowsPointingOutIcon, MapPinIcon, XMarkIcon } from "@heroicons/react/24/outline";

// Harita AYRI paket + React.lazy: react-leaflet ESM olduğu için STATİK import
// onu yalnızca dolaylı çeken sohbet testlerini bile kırar. Konumsuz mesajda bu
// modül hiç yüklenmez.
const KonumHarita = lazy(() => import("./KonumHarita"));

// FAZ-55/9 — MESAJDAKİ HARİTA ARTIK BİR ARAÇ.
// Kullanıcı (2026-07-28): "haritaya yakınlaştır, uzaklaştır zoom falan ekle,
// tam ekran ekle, tam ekran ekleyince tam ekranda açılsın … konum tarif et
// butonu falan ekleyebilirsin ama minik."
//   • Zoom düğmeleri + sürükleme haritanın kendisinde (bkz. KonumHarita).
//   • "Tam ekran" → sayfanın tamamını kaplayan, tekerlek zoom'u da açık harita.
//   • "Yol tarifi" → dış harita uygulamasında tarif (ekip sahaya gidecek).
// Düğmeler haritanın ÜSTÜNDE minik rozetler; kartın "detaya git" tıklamasını
// çalmasınlar diye harita bloğu kartın tıklanabilir gövdesinin DIŞINDADIR
// (iç içe <button> hem geçersiz HTML hem de tıklama karmaşası olurdu).
export default function KonumBlok({ enlem, boylam }) {
  const [tam, setTam] = useState(false);
  const tarifUrl = `https://www.google.com/maps/dir/?api=1&destination=${enlem},${boylam}`;
  return (
    <>
      <div className="msj-refmsg-harita" aria-label="Talep konumu">
        <Suspense fallback={<div className="msj-refmsg-harita-bos">Harita…</div>}>
          <KonumHarita nokta={{ lat: enlem, lng: boylam }} capMetre={50} onSec={() => {}} mini />
        </Suspense>
        <div className="msj-harita-arac">
          <a
            className="msj-harita-btn"
            href={tarifUrl}
            target="_blank"
            rel="noopener noreferrer"
            title="Yol tarifi al"
            aria-label="Yol tarifi al"
          >
            <MapPinIcon />
          </a>
          <button
            type="button"
            className="msj-harita-btn"
            onClick={() => setTam(true)}
            title="Tam ekran"
            aria-label="Haritayı tam ekran aç"
          >
            <ArrowsPointingOutIcon />
          </button>
        </div>
      </div>
      {tam && (
        <div className="msj-harita-tam" role="dialog" aria-modal="true" aria-label="Konum — tam ekran">
          <div className="msj-harita-tam-bar">
            <span className="msj-harita-tam-koord">
              {enlem.toFixed(5)}, {boylam.toFixed(5)}
            </span>
            <a
              className="msj-harita-btn"
              href={tarifUrl}
              target="_blank"
              rel="noopener noreferrer"
              title="Yol tarifi al"
              aria-label="Yol tarifi al"
            >
              <MapPinIcon />
            </a>
            <button
              type="button"
              className="msj-harita-btn"
              onClick={() => setTam(false)}
              title="Kapat"
              aria-label="Tam ekranı kapat"
            >
              <XMarkIcon />
            </button>
          </div>
          <div className="msj-harita-tam-govde">
            <Suspense fallback={<div className="msj-refmsg-harita-bos">Harita…</div>}>
              <KonumHarita
                nokta={{ lat: enlem, lng: boylam }}
                capMetre={50}
                onSec={() => {}}
                mini
                tamEkran
              />
            </Suspense>
          </div>
        </div>
      )}
    </>
  );
}
